import { requestToolGet, requestToolPost } from '@/common/request';
class ToolApis {
  // 开始任务
  taskStart = async (params) => {
    return await requestToolGet('/task/start', params);
  };

  // 开始任务
  taskStartBatch = async (params) => {
    return await requestToolGet('/task/startBatch', params);
  };

  // 进度同步
  taskProgress = async (params) => {
    return await requestToolGet('/task/progress', params);
  };
}

export default new ToolApis();
